import { Injectable } from '@angular/core';
import * as uuid from 'uuid';
import { NOTIFICATIONS, NotificationsService } from '../../../../core/service/notifications.service';
import { ChunkUploadBackendService } from './chunk-upload-backend.service';
import { lastValueFrom } from 'rxjs';
import { ChunkUploadDto } from '../../models/DTOs/gl-upload/ChunkUploadDto';

@Injectable({
  providedIn: 'root',
})
export class ChunkUploadService {
  constructor(
    private notificationsService: NotificationsService,
    private backendService: ChunkUploadBackendService,
  ) {}

  /**
   * Sends data in chunks to the specified URL and verifies storage.
   *
   * @returns A tuple containing the session UUID and the total number of chunks sent
   * to be provided lately to save combined data.
   */
  async sendChunkedData(data: any[]): Promise<[string, number]> {
    const chunks: ChunkUploadDto[] = this.splitDataIntoChunks(data);
    for (const chunk of chunks) {
      try {
        await lastValueFrom(this.backendService.sendChunk(chunk));
      } catch (error) {
        this.notificationsService.error(NOTIFICATIONS.CHUNK_UPLOAD_ERROR);
        throw error;
      }
    }
    return [chunks[0].sessionId, chunks.length];
  }

  splitDataIntoChunks(data: any[]): ChunkUploadDto[] {
    const dataSizeKB = JSON.stringify(data).length / 1024;
    const totalChunks = Math.ceil(dataSizeKB / chunkSizeKB);
    const stepSize = Math.ceil(data.length / totalChunks);
    const sessionId = uuid.v4(); // Initialize sessionId

    const chunks: ChunkUploadDto[] = [];
    for (let i = 0; i < data.length; i += stepSize) {
      const dataChunk = data.slice(i, i + stepSize);
      const chunkNumber = Math.floor(i / stepSize);
      const chunkedUploadDto = new ChunkUploadDto(totalChunks, chunkNumber, JSON.stringify(dataChunk), sessionId);
      chunks.push(chunkedUploadDto);
    }
    return chunks;
  }
}

export const chunkSizeKB = 700; // 700 KB is chosen due to nginx limitations
